/* ------------------------------------------------------------------
   Mr Football - "Try your luck" card popup.
   Rendered by sections/mailing-popup.liquid.

   Flow: pick cards -> offer + "who are you shopping for" -> email -> done.

   WHO SEES IT
   -----------
   Three separate gates, because "dismissed" and "already signed up" are
   not the same thing and must not share a cooldown:

     * converted  -> permanent. Someone who gave us their email is never
                     asked again. (Before this existed, subscribers got
                     re-pitched a week later, which reads as careless.)
     * dismissed  -> cooldown, default 7 days, per browser.
     * known      -> if Klaviyo already recognises the visitor (they
                     clicked in from one of our emails), skip it. This is
                     what Klaviyo's own forms do. Fails open: if the check
                     errors or is slow, the popup still shows.

   Customer accounts are DISABLED on this store, so nobody is ever logged
   in and the theme cannot know server-side who is a customer. All of the
   above is necessarily browser-side.

   EMAIL CAPTURE
   -------------
   This shop enforces Shopify's invisible hCaptcha on customer forms.
   Verified against the live storefront on 2026-09-21:
     * fetch() POST to /contact  -> 400 "Missing CAPTCHA token"
     * form.submit()             -> also 400; it skips the submit EVENT
                                    that hCaptcha hooks
     * a genuine submit          -> hCaptcha engages correctly

   So there are two paths:
     1. KLAVIYO (preferred). CORS-enabled, no captcha, no page reload.
        Needs a List ID. Klaviyo is this store's email platform.
     2. NATIVE SHOPIFY FORM (fallback when no List ID). We do NOT intercept
        it - the shopper's own click submits the real form, which is the
        only thing carrying a valid token. The page reloads, so we stash
        state first and re-open on the confirmation step afterwards.

   Debug: ?mfp=preview forces it open (ignores every gate),
          ?mfp=reset clears the dismissed AND converted flags.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfLuckyPopup) { return; }
  window.__mfLuckyPopup = true;

  var root, cfg;
  var SEEN_KEY = 'mf_lucky_popup_seen';       // dismissed - cooldown
  var DONE_KEY = 'mf_lucky_popup_done';       // converted - permanent
  var PENDING_KEY = 'mf_lucky_popup_pending';
  var SKIP_KNOWN_PROFILES = true;             // see "WHO SEES IT" above
  var KNOWN_CHECK_TIMEOUT_MS = 1200;
  var segment = '';

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function params() {
    try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
  }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  function lset(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lget(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function ldel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  function hasConverted() { return !!lget(DONE_KEY); }
  function markConverted() { lset(DONE_KEY, String(Date.now())); }

  function dismissedRecently() {
    var raw = lget(SEEN_KEY);
    if (!raw) { return false; }
    var days = parseInt(cfg.frequency, 10) || 7;
    return (Date.now() - parseInt(raw, 10)) < days * 86400000;
  }
  function markDismissed() { lset(SEEN_KEY, String(Date.now())); }

  /* Klaviyo already knows this browser? Resolves false on any error or if
     it takes too long - we would rather show the popup than lose a signup. */
  function isKnownProfile() {
    return new Promise(function (resolve) {
      if (!SKIP_KNOWN_PROFILES) { return resolve(false); }
      var settled = false;
      function done(v) { if (!settled) { settled = true; resolve(!!v); } }
      var timer = window.setTimeout(function () { done(false); }, KNOWN_CHECK_TIMEOUT_MS);
      try {
        if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
          var r = window.klaviyo.isIdentified();
          if (r && typeof r.then === 'function') {
            r.then(function (v) { window.clearTimeout(timer); done(v); })
             .catch(function () { window.clearTimeout(timer); done(false); });
            return;
          }
          window.clearTimeout(timer);
          return done(r);
        }
      } catch (e) {}
      window.clearTimeout(timer);
      done(false);
    });
  }

  /* ---------------- open / close / steps ---------------- */

  function open(atStep) {
    root.hidden = false;
    window.requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    markDismissed();   // opening starts the cooldown; converting overrides it
    if (atStep) { step(atStep); }
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { root.hidden = true; }, 260);
  }

  function step(name) {
    qsa('[data-step]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-step') === name);
    });
    if (name === 'done') { markConverted(); }
  }

  /* ---------------- step 1: cards ---------------- */

  var flipped = 0, advancing = false;

  function onCard(btn) {
    if (btn.classList.contains('is-flipped') || advancing) { return; }
    btn.classList.add('is-flipped');
    btn.setAttribute('aria-pressed', 'true');
    flipped += 1;

    var need = parseInt(cfg.matchCount, 10) || 3;
    if (flipped >= need) {
      advancing = true;
      window.setTimeout(function () {
        qsa('[data-mfp-card]').forEach(function (c) { c.classList.add('is-flipped'); });
      }, 260);
      window.setTimeout(function () { step('offer'); }, 1050);
    }
  }

  /* ---------------- step 2: segment ---------------- */

  function setDoneCta(href) {
    var cta = qs('[data-mfp-done-cta]');
    if (cta && href) { cta.setAttribute('href', href); }
  }

  function onSegment(btn) {
    segment = btn.getAttribute('data-mfp-segment') || '';
    setDoneCta(btn.getAttribute('data-mfp-href') || '');

    // Cart attributes ride along to the order, so this shows up in admin.
    if (segment) {
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Shopping for': segment } })
        }).catch(function () {});
      } catch (e) {}
    }
    step('email');
    var input = qs('[data-mfp-email]');
    if (input) { window.setTimeout(function () { try { input.focus(); } catch (e) {} }, 120); }
  }

  /* ---------------- step 3: email ---------------- */

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  }

  function identifyInKlaviyo(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ $email: email });
      }
    } catch (e) {}
  }

  function subscribeViaKlaviyo(email) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.klaviyoList } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) { throw new Error('klaviyo ' + r.status); }  // 202 = accepted
      return true;
    });
  }

  function showError(msg) {
    var err = qs('[data-mfp-error]');
    if (err) { err.hidden = false; err.textContent = msg; }
  }
  function clearError() {
    var err = qs('[data-mfp-error]');
    if (err) { err.hidden = true; }
  }
  function setBusy(on) {
    var btn = qs('[data-mfp-submit]');
    if (!btn) { return; }
    if (!btn.getAttribute('data-label')) { btn.setAttribute('data-label', btn.textContent.trim()); }
    btn.disabled = !!on;
    if (on) { btn.textContent = 'Unlocking...'; }
    else { btn.textContent = btn.getAttribute('data-label'); }
  }

  function onSubmit(e) {
    var input = qs('[data-mfp-email]');
    if (!input) { return; }
    var email = input.value.trim();

    if (!validEmail(email)) {
      e.preventDefault();
      showError('Please enter a valid email address.');
      input.focus();
      return;
    }
    clearError();
    identifyInKlaviyo(email);

    if (cfg.klaviyoList && cfg.klaviyoCompany) {
      e.preventDefault();
      setBusy(true);
      subscribeViaKlaviyo(email)
        .then(function () { setBusy(false); step('done'); })
        .catch(function () {
          setBusy(false);
          showError('That did not save. Press the button once more to try again.');
          cfg.klaviyoList = '';   // next click falls through to the native submit
        });
      return;
    }

    // Native path: DO NOT preventDefault. The shopper's own click carries
    // the hCaptcha token. Stash state so we can resume after the reload.
    var cta = qs('[data-mfp-done-cta]');
    sset(PENDING_KEY, JSON.stringify({
      segment: segment,
      href: cta ? cta.getAttribute('href') : ''
    }));
    setBusy(true);
  }

  /* ---------------- boot ---------------- */

  function returningFromNativeSubmit() {
    var p = params();
    if (!p || p.get('customer_posted') !== 'true') { return null; }
    var raw = sget(PENDING_KEY);
    sdel(PENDING_KEY);
    if (!raw) { return { segment: '', href: '' }; }
    try { return JSON.parse(raw); } catch (e) { return { segment: '', href: '' }; }
  }

  function boot() {
    root = document.querySelector('[data-mfp]');
    if (!root) { return; }

    cfg = {
      enabled: root.getAttribute('data-enabled') === 'true',
      delay: parseInt(root.getAttribute('data-delay'), 10) || 0,
      frequency: root.getAttribute('data-frequency') || '7',
      matchCount: root.getAttribute('data-match') || '3',
      klaviyoList: root.getAttribute('data-klaviyo-list') || '',
      klaviyoCompany: root.getAttribute('data-klaviyo-company') || ''
    };

    qsa('[data-mfp-card]').forEach(function (c) {
      c.addEventListener('click', function () { onCard(c); });
    });
    qsa('[data-mfp-segment]').forEach(function (b) {
      b.addEventListener('click', function () { onSegment(b); });
    });
    qsa('[data-mfp-close]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); close(); });
    });

    // Liquid's {% form %} will not take a hyphenated data attribute, so the
    // real customer form is identified by id.
    var form = document.getElementById('mfp-form') || qs('[data-mfp-form]');
    if (form) { form.addEventListener('submit', onSubmit); }

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !root.hidden) { close(); }
    });

    // Came back from the native Shopify form - show the confirmation.
    var back = returningFromNativeSubmit();
    if (back) {
      if (back.href) { setDoneCta(back.href); }
      open('done');
      return;
    }

    var p = params();
    if (p && p.get('mfp') === 'reset') {
      ldel(SEEN_KEY);
      ldel(DONE_KEY);
    }
    if (p && p.get('mfp') === 'preview') { open(); return; }   // ignores all gates

    if (!cfg.enabled) { return; }
    if (hasConverted()) { return; }
    if (dismissedRecently()) { return; }
    if (window.Shopify && window.Shopify.designMode) { return; }

    window.setTimeout(function () {
      isKnownProfile().then(function (known) {
        if (known) { return; }
        open();
      });
    }, cfg.delay * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ==================================================================
   SUPPRESS THE LEGACY KLAVIYO "UNLOCK 10% OFF" POPUP (form XkSbBM)
   ==================================================================

   WHY THIS EXISTS
   ---------------
   Klaviyo form XkSbBM (version 22126577) is PUBLISHED and fires 5s after
   page load on every page. The popup above fires at 6s. Both subscribe to
   the SAME list (TjcSLL), which triggers the SAME Email Welcome Series -
   so one shopper was being promised a FREE GIFT by one popup and 10% OFF
   by the other, in a single session, then sent a welcome email matching
   only one of them. Verified live on 2026-09-21/22.

   The merchant chose the free gift as the single offer.

   WHY IT IS DONE HERE AND NOT IN KLAVIYO
   --------------------------------------
   Klaviyo's API exposes NO way to unpublish or draft a form - only
   permanent deletion, which destroys the design, both versions and the
   reporting history irreversibly. The merchant also could not reach the
   Klaviyo UI (login verification codes were not arriving). This is the
   reversible option: the form still exists untouched in Klaviyo.

   SCOPE - DELIBERATELY NARROW
   ---------------------------
   Matches ONE form id. It does NOT touch klaviyo.js, tracking,
   identify(), isIdentified(), or any other Klaviyo form - the popup above
   depends on isIdentified() to skip known profiles, and any embedded
   signup forms must keep working.

   TO REVERT: delete this block. Nothing else references it.
   PROPER FIX: set form XkSbBM to Draft in the Klaviyo UI, then delete
   this block - that is cleaner than fighting the script forever.
================================================================== */
(function () {
  'use strict';
  if (window.__mfKlSuppress) { return; }
  window.__mfKlSuppress = true;

  var FORM_ID = 'XkSbBM';
  var SELECTOR = '[data-testid="klaviyo-form-' + FORM_ID + '"]';

  function releaseScrollLock() {
    // Klaviyo locks the page behind its modal. Removing the modal without
    // undoing this leaves the page unscrollable.
    try {
      [document.documentElement, document.body].forEach(function (el) {
        if (!el) { return; }
        if (el.style.overflow === 'hidden') { el.style.overflow = ''; }
        if (el.style.position === 'fixed') {
          el.style.position = '';
          el.style.top = '';
          el.style.width = '';
        }
      });
    } catch (e) {}
  }

  function kill() {
    var form;
    try { form = document.querySelector(SELECTOR); } catch (e) { return false; }
    if (!form) { return false; }

    // Walk up to the outermost fixed container Klaviyo renders the modal
    // into, so the dimmed overlay goes with it instead of being left over
    // the page.
    var node = form, outer = form;
    while (node && node !== document.body) {
      var pos = '';
      try { pos = window.getComputedStyle(node).position; } catch (e) {}
      if (pos === 'fixed' || node.hasAttribute('data-kl-scroll-locking-modal')) { outer = node; }
      node = node.parentElement;
    }

    try { outer.parentNode.removeChild(outer); }
    catch (e) { try { outer.style.display = 'none'; } catch (e2) {} }
    releaseScrollLock();
    return true;
  }

  kill();

  // The form is injected asynchronously and can be re-injected, so watch
  // rather than firing once. Self-disconnects so it is not a permanent
  // observer on every page.
  var hits = 0;
  try {
    var mo = new MutationObserver(function () {
      if (kill()) { hits += 1; }
      if (hits >= 5) { mo.disconnect(); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 30000);
  } catch (e) {}
})();